import { put, takeLatest } from "redux-saga/effects";
import {
  fetchThreadsRequest,
  fetchThreadsSuccess,
  fetchThreadsFailure,
  createThreadRequest,
  createThreadSuccess,
  createThreadFailure,
  deleteThreadRequest,
  deleteThreadSuccess,
  deleteThreadFailure,
} from "./threadsSlice";
import { fastApiURL } from "../../utils/config";
import TokenManager from "../../utils/tokenManager"; 


function* fetchThreadsSaga(action) {
  try {
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("Not authenticated");

    const response = yield fetch(`${fastApiURL}/api/threads`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`, 
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to load threads: ${response.status}`);
    }

    const threads = yield response.json();

    const formattedThreads = threads
      .map((thread) => ({
        id: thread.thread_id,
        title: thread.title || "Untitled Chat",
        created_at: thread.created_at,
        updated_at: thread.updated_at,
      }))
      .sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });

    yield put(fetchThreadsSuccess(formattedThreads));
  } catch (error) {
    console.error("Error in fetchThreadsSaga:", error);
    yield put(fetchThreadsFailure(error.message));
  }
}

function* createThreadSaga(action) {
  try {
    const { title, knowledge_filter } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("Not authenticated");

    const response = yield fetch(`${fastApiURL}/api/threads`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      body: JSON.stringify({
        title: title || `Chat - ${new Date().toLocaleString()}`,
        knowledge_filter: knowledge_filter || { labels: ["general"] },
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to create thread: ${response.status}`);
    }

    const threadData = yield response.json();
    const formattedThread = {
      id: threadData.thread_id,
      title: threadData.title || "Untitled Chat",
      created_at: threadData.created_at,
      updated_at: threadData.updated_at,
    };

    yield put(createThreadSuccess(formattedThread));
  } catch (error) {
    console.error("Error in createThreadSaga:", error);
    yield put(createThreadFailure(error.message));
  }
}

function* deleteThreadSaga(action) {
  try {
    const { threadId } = action.payload;
    const token = TokenManager.getAccessToken(); 
    if (!token) throw new Error("Not authenticated");

    const response = yield fetch(`${fastApiURL}/api/threads/${threadId}`, {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${token}`, 
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete thread: ${response.status}`);
    }

    yield put(deleteThreadSuccess(threadId));
  } catch (error) {
    console.error("Error in deleteThreadSaga:", error);
    yield put(deleteThreadFailure(error.message));
  }
}

export function* watchThreadsSaga() {
  yield takeLatest(fetchThreadsRequest, fetchThreadsSaga);
  yield takeLatest(createThreadRequest, createThreadSaga);
  yield takeLatest(deleteThreadRequest, deleteThreadSaga);
}